import { Main2SectionWrap, Main2SectionContent } from 'src/styles/views/Main/main2'
import main2bg1 from 'src/assets/main/main2/main2bg1.png'
import main2bg2 from 'src/assets/main/main2/main2bg2.png'
import main2bg3 from 'src/assets/main/main2/main2bg3.png'
import main2img1 from 'src/assets/main/main2/main2img1.json'
import main2img2 from 'src/assets/main/main2/main2img2.json'
import main2img3 from '../../assets/main/main2/main2img3.json'
import useWindowDimensions from '../../hooks/useGetWindowSize'
import mo_main2bg1 from '../../assets/main/main2/mo_main2bg1.png'
import mo_main2bg2 from '../../assets/main/main2/mo_main2bg2.png'
import mo_main2bg3 from '../../assets/main/main2/mo_main2bg3.png'
import Lottie from 'lottie-react'
import React from 'react'

const Main2Item = [
  {
    bgSrc: main2bg1,
    moBgSrc: mo_main2bg1,
    imgSrc: main2img1,
    moImgSrc: main2img1,
    shadow: 'rgba(255, 182, 210, 0.4)',
    title: '실시간 위치 확인',
    desc: '실시간으로 가족 혹은 친구의 위치를 확인해 보세요.'
  },
  {
    bgSrc: main2bg2,
    moBgSrc: mo_main2bg2,
    imgSrc: main2img2,
    moImgSrc: main2img2,
    shadow: 'rgba(255, 238, 87, 0.4)',
    title: '안심장소 등록하고 알림 받기',
    desc: '안심장소에 오고갈 때 알림을 받을 수 있습니다.'
  },
  {
    bgSrc: main2bg3,
    moBgSrc: mo_main2bg3,
    imgSrc: main2img3,
    moImgSrc: main2img3,
    shadow: 'rgba(153, 220, 250, 0.4)',
    title: '유용하고 다양한 정보 확인',
    desc: '활동량, 날씨, 건강관리 콘텐츠 등 다양한 정보를 확인해 보세요.'
  }
]

const Main2Section = () => {
  const { width } = useWindowDimensions()

  return (
    <Main2SectionWrap>
      <div>
        <h3>떨어져 있어도 늘 함께!</h3>
        {Main2Item.map((option: any, index: number) => (
          <Main2SectionContent
            key={option.title} bgSrc={width > 1200 ? option.bgSrc : option.moBgSrc}
            boxShadow={option.shadow}
          >
            <div>
              <h3>{option.title}</h3>
              <p>{option.desc}</p>
            </div>
            {width > 1200
              ? <Lottie animationData={option?.imgSrc} className='lottie' />
              : <Lottie animationData={option?.moImgSrc} className='lottie' />}
          </Main2SectionContent>
        ))}
      </div>
    </Main2SectionWrap>
  )
}
export default Main2Section
